import { ReadRequest } from "~/backendApis/foundation/ReadRequest"
import { PaidPlanListView } from "~/backendApis/viewModel"

interface Params {
  universalCorporationId: string
}

export class GetAppliablePaidPlanListReadRequest extends ReadRequest<PaidPlanListView> {
  private readonly params: Params

  constructor(params: Params) {
    super()
    this.params = params
  }

  public get(): Promise<PaidPlanListView> {
    return this.apiClient.get(this.makeEndpoint())
  }

  private makeEndpoint(): string {
    return `/corporation_contract/corporation_member/${this.params.universalCorporationId}/applicable_paid_plan/list`
  }
}
